import { oz } from '@vy/utils';

export const RefundFormSchema = oz.object({
  amount: oz.number().min(0, 'Amount must be greater than 0'),
  serviceName: oz.string(),
  date: oz.date(),
  customerId: oz.string(),
});

export type RefundFormValues = oz.infer<typeof RefundFormSchema>;
